import styled from "styled-components";
import { Button,ButtonGroup } from "@vds/buttons";


export const ProgressBarContainer = styled.div`
  display: flex;
  width: 1363px;
  align-items: flex-start;
  justify-content: space-between;

`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  flex: 1 0 0;
  margin: 0 8px;
  cursor: pointer;
`;

export const TopBar = styled.div`
  background: ${(props) =>
    props.index < props.currentSectionIndex
      ? "#008331"
      : props.index === props.currentSectionIndex
      ? "#000000"
      : "#D8DADA"};
  height: 4px;
  align-self: stretch;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 35px;
  width: auto;
  height: auto;
`;

export const ContainerWithButtons = styled.div`
  display: flex;
  width: 1363px;
  justify-content: space-between;
  align-items: center;
`;

export const SaveAndCancelButtons = styled.div`
    {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      gap: var(--space-3X, 12px);
      width: auto;
      height: auto;
    }
    div {
      padding-bottom: 0;
    }
`;

export const BackAndNextButtonsContainer = styled.div`
  display: flex;
  width: 808px;
  justify-content: space-between !important;
  align-items: center;
  height: auto;
  margin-top: 15px;
`;

export const TitleHeading = styled.h1`
  color: #000000;
  font-family: Verizon NHG DS;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  height: 28px;
`;

export const SectionText = styled.div`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS; // Note: Ensure the font is available or fallback is set
  font-size: 16px;
  font-style: normal;
  font-weight: ${(props) => props.index === props.currentSectionIndex ? 700 : 400};
  line-height: 20px; /* 125% */
  letter-spacing: 0.5px;
`;

export const FrameForDataContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: auto;
  height: auto;
`;

export const TitleOfContent = styled.h2`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Verizon NHG DS;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 116.667% */
  height: auto;
  width: auto;
`;

export const ContentGrayContainer = styled.div`
  display: flex;
  width: 808px;
  height: 637px;
  padding: 24px;
  height: ${(props) => props.contentHeight};
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const FloorText=styled.p`
color: #000;
font-feature-settings: 'clig' off, 'liga' off;
font-family: "Verizon NHG DS";
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 125% */
letter-spacing: 0.5px;
margin-top: 10px;
`;

export const FloorPlanText=styled.p`
color: #000;
font-feature-settings: 'clig' off, 'liga' off;
font-family: "Verizon NHG DS";
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 125% */
letter-spacing: 0.5px
`;

export const AutomaticColibrationText=styled.p`
float:left;
margin-top:5px;
`;

export const AutomaticColibrationYes=styled.div`
border-top:3px solid green;
`;

export const AutomaticColibrationNo=styled.div`
border-top:3px solid orange;
`;
export const ColibrationHeadingYes = styled.h3`
color:green;
margin-top:5px;
`;

export const ColibrationHeadingNo = styled.h3`
color:orange;
margin-top:5px;
`;




export const FloorImage = styled.img`
    width: 384px;
    height: 234px;
    padding: 16px 0px 0px 0px;
    gap: 10px;
    border-radius: 8px 0px 0px 0px;
    opacity: 0px;
`;



export const ReviewPageSmallText=styled.p`
color: #000;
font-feature-settings: 'clig' off, 'liga' off;
font-family: "Verizon NHG DS";
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 20px;
letter-spacing: 0.5px
text-align: left;
`;

export const ReviewPageMediumText=styled.p`
color: #000;
font-feature-settings: 'clig' off, 'liga' off;
font-family: "Verizon NHG DS";
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
letter-spacing: 0.5px
text-align: left;
`;

export const ReviewPageText=styled.p`
color: #000;
font-feature-settings: 'clig' off, 'liga' off;
font-family: "Verizon NHG DS";
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 24px;
letter-spacing: 0.5px
text-align: left;
margin-left: 35px;
`;

export const Greencontainer = styled.div`
    width: 600px;
    height: 304px;
    top: 215px;
    left: 463px;
    padding: 40px 24px 40px 24px;
    display: flex;
    flex-direction: column;
    gap: 22px;
    border-radius: 8px;
    border: 4px solid var(--green-26, #008331);
`;

export const IconStyle=styled.div`
  position: absolute;
  width: 74px;
  height: 74px;
  gap: 0px;
  left:390px;
  top:235px;
`;

export const SnapShotContainer = styled.div`
  width: 641px;
  height: 326px;
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  margin-bottom: 8px;
`;

export const Image = styled.img`
  width: 142px;
  height: 91px;
  opacity: 1; 
`;

export const AutoHeightContainer = styled.div`
{
  height: auto;
}`

export const FloorPreviewContainer = styled.div`
{
    display: flex;
    gap: 25px;
}`

export const AreaSelectContainer = styled.div`{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%
}`

export const FloorPlanContainer = styled.div`
    width: 100%;
    overflow: hidden;
    background: var(--vds-background-secondary-light, #F6F6F6);
    display: flex;
    justify-content: center;
    align-items: center;
`

export const LoaderContainer = styled.div`
  {
    position: relative;
    width: 50px;
    height: 50px;
  }
`;


export const ChildContainer = styled.div`
  {
    display: flex;
    width: 764px;
    height: auto;
    margin-top: 10px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CompanionGrayContainer = styled.div`
  display: flex;
  width: 808px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const FloorGrayContainer = styled.div`
  display: flex;
  width: 808px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const PlaceCameraGrayContainer = styled.div`
  display: flex;
  width: 808px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const AssignGrayContainer = styled.div`
  display: flex;
  width: 808px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);

  @media (max-width: 1272px) and (min-width: 1024px) {
    max-width: 723px;
    /* max-height: 346px; */
  }
  @media (max-width: 1680px) and (min-width: 1272px) {
    /* max-height: 346px; */
    max-width:805px;
  }
  @media (max-width: 1680px){
  /* max-height: 346px; */
    max-width:904px;
  }
`;

export const NameStreamGrayContainer = styled.div`
  display: flex;
  width: 808px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const NameStreamOptionalBlueContainer = styled.div`
  display: flex;
  width: 684px;
  height: 190px;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;
  background: var(--gray-95, #E3F2FD);
`;

export const StreamText=styled.p`
  color: #000;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Verizon NHG eDS;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
 `; 

export const StreamSmallText=styled.p`
color: #000;
font-feature-settings: "clig" off, "liga" off;
font-family: "Verizon NHG DS";
font-size: 1.2rpx;
font-style: normal;
font-weight: 400;
line-height: 18px;
letter-spacing: 0.5px;
`;

export const StreamDescriptiveText = styled.p`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Verizon NHG DS";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

export const FrameForAllFOVs = styled.div`
  width: 760px;
  height: auto;
  gap: 17px;
  border-radius: 4px 0px 0px 0px
`;

export const FrameForIMGandInput = styled.div`
  width: 480px;
  height: 91px;
  display: flex;
  gap: 10px;
  opacity: 1;
  margin-bottom: 30px;
`;

export const FrameForImages = styled.div`
  width: 142px;
  height: 91px;
  overflow: hidden;
  opacity: 1;
`;

export const FrameForLabelAndInput = styled.div`
  width: 328px;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: var(--space1X);
  justify-content: center;
  opacity: 1;
`;

export const ReviewFovBlock = styled.div`
{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}`;

export const ReviewFovImage = styled.div`
    img {
      width: 142px;
      height: 91px; 
    }
}`;

export const ReviewFovName = styled.div`
{
    width: 30%
}`;

export const ReviewBlockRow=styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`;

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 808px;
  height:auto;
  padding: 24px;
  gap: 20px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const CompanionTabContainer = styled.div`
  display: flex;
  width: 708px;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  height: auto;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const FloorTabContainer = styled.div`
  display: flex;
  width: 708px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const AreaTabContainer = styled.div`
  display: flex;
  width: 708px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const StreamNameTabContainer = styled.div`
  display: flex;
  width: 708px;
  height: auto;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const StyledEditButton = styled.div`
width: 153px;
height: 32px;
border-radius: 24px 24px 24px 24px;
margin-left: 530px;
margin-top: -70px;
border: 1px solid var(--elements-primary, #000000)
z-index: 999;
`;

export const CustomContainer = styled.div`
  width: 760px;
  height: 64px;
  gap: 0px;
  justify-content: space-between;
  opacity: 0px;
`;

export const StyledStreamButton = styled.div`
  width: 110px;
  height: 32px;
  margin-left: 400px;
  margin-top: -70px;
`;

export const BlurModalContainer = styled.div`
display: flex;
width: 808px;
height: 298px;
padding: 24px;
flex-direction: column;
align-items: flex-start;
gap: 22px;
border-radius: 8px;
background: var(--gray-95, #f6f6f6);
`
export const BlurTitleText = styled.div`
color: #000;
font-feature-settings: "clig" off, "liga" off;
font-family: "Verizon NHG DS";
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
letter-spacing: 0.5px;
`
export const BlurOptionalText = styled.div`
color: #6F7171;
font-feature-settings: "clig" off, "liga" off;
font-family: "Verizon NHG DS";
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
letter-spacing: 0.5px;
`